"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useInView = void 0;
const react_1 = require("react");
function useInView({ threshold = 0, root = null, rootMargin = '0%', freezeOnceVisible = false, } = {}) {
    const elementRef = (0, react_1.useRef)(null);
    const [entry, setEntry] = (0, react_1.useState)();
    const frozen = (entry === null || entry === void 0 ? void 0 : entry.isIntersecting) && freezeOnceVisible;
    const updateEntry = ([e]) => {
        setEntry(e);
    };
    (0, react_1.useEffect)(() => {
        const node = elementRef === null || elementRef === void 0 ? void 0 : elementRef.current;
        const hasIOSupport = !!window.IntersectionObserver;
        if (!hasIOSupport || frozen || !node) {
            return;
        }
        const observerParams = { threshold, root, rootMargin };
        const observer = new IntersectionObserver(updateEntry, observerParams);
        observer.observe(node);
        return () => observer.disconnect();
    }, [elementRef === null || elementRef === void 0 ? void 0 : elementRef.current, JSON.stringify(threshold), root, rootMargin, frozen]);
    return (0, react_1.useMemo)(() => ({
        ref: elementRef,
        entry,
        inView: Boolean(entry === null || entry === void 0 ? void 0 : entry.isIntersecting),
    }), [entry]);
}
exports.useInView = useInView;
